module.exports = __webpack_public_path__ + "arrow_hero_looping.svg?56b735a17191570fe67ffd734394963b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_hero_looping.svg
// module id = 41
// module chunks = 0